import { lazy } from "react";

export const list = lazy(() => import("./View").then(m => ({ default: m.RiskDataView })));
